import {
  ActivityIcon,
  BarChart3Icon,
  FileTextIcon,
  GaugeIcon,
  MailIcon,
  SlidersHorizontalIcon,
  UsersIcon,
  type LucideIcon,
} from "lucide-react";

export type DashboardPage =
  | "overview"
  | "analytics"
  | "users"
  | "emails"
  | "usage"
  | "logs"
  | "settings";

export const dashboardPages: Array<{
  id: DashboardPage;
  label: string;
  description: string;
  icon: LucideIcon;
  managerOnly?: boolean;
}> = [
  {
    id: "overview",
    label: "Overview",
    description: "Traffic, email health, and provider status at a glance",
    icon: GaugeIcon,
  },
  {
    id: "analytics",
    label: "Analytics",
    description: "24 hour request, failure, and delivery breakdowns",
    icon: BarChart3Icon,
  },
  {
    id: "users",
    label: "Users",
    description: "Accounts, keys, and recorded activity",
    icon: UsersIcon,
    managerOnly: true,
  },
  {
    id: "emails",
    label: "Email events",
    description: "Queue, delivery, and resend records",
    icon: MailIcon,
  },
  {
    id: "usage",
    label: "API usage",
    description: "Protected route request logs",
    icon: ActivityIcon,
  },
  {
    id: "logs",
    label: "Logs",
    description: "Recent operational errors and warnings",
    icon: FileTextIcon,
  },
  {
    id: "settings",
    label: "Settings",
    description: "Provider routing and test sends",
    icon: SlidersHorizontalIcon,
  },
];

export function dashboardPageFromPath(path: string): DashboardPage {
  const normalized = path.replace(/^#?\/?/, "").split("/")[0];
  const page = dashboardPages.find((item) => item.id === normalized);
  return page?.id ?? "overview";
}

export function dashboardPagePath(page: DashboardPage): string {
  return `#/${page}`;
}
